export default {
    // Local .NET API - run from BestStart.PowerBiEmbed.Api with the https profile
    csharpBackendUrl: 'https://localhost:7272',
    clientId: '03e8231b-c148-4559-8ffa-f28f6142fd96',
    authority: 'https://login.microsoftonline.com/e5982410-a87c-4de2-966a-57de40702c63',
    // Optional local fallback when the browser has multiple Microsoft accounts signed in.
    // Prefer passing login_hint in the SharePoint URL when possible.
    loginHint: import.meta.env.VITE_LOGIN_HINT || '',
    preferredLoginDomains: ['best-start.org'],
    LogLevel: 5,
};
